import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
    name: 'behavior',
})

export default class Behavior extends Vue {

    // -------------------------------------------------------------
    // Properties

    @Prop()
    private chartData: any;

    @Prop({default: 150})
    private maxWidth?: any;

    @Prop({default: 100})
    private maxHeight?: any;

    private skylinePoints: any = [];

    private behaviorData: any = [
        {
            label: 'Talk-Out',
            competencies: [{
                name: 'mastered',
                count: 2,
            }, {
                name: 'inprogress',
                count: 1,
            }, {
                name: 'notstarted',
                count: 2,
            }],
        },
        {
            label: 'Tantrum',
            competencies: [{
                name: 'mastered',
                count: 1,
            }, {
                name: 'notstarted',
                count: 3,
            }, {
                name: 'notstarted',
                count: 1,
            }],
        },
        {
            label: 'Out of Seat',
            competencies: [{
                name: 'mastered',
                count: 1,
            }, {
                name: 'inprogress',
                count: 1,
            }, {
                name: 'notstarted',
                count: 3,
            }],
        },
        {
            label: 'Engagement',
            competencies: [{
                name: 'mastered',
                count: 3,
            }, {
                name: 'inprogress',
                count: 1,
            }, {
                name: 'notstarted',
                count: 1,
            }],
        },
    ];

    private maxCount: number = 5;

    @Prop({default: false})
    private isShowText?: boolean;


    // ---------------------------------------------------------------------------
    // Hooks

    private mounted() {
        if (this.chartData) {
            this.behaviorData = this.chartData;
        }
        this.drawChart();
    }

    // ---------------------------------------------------------------------------
    // Methods

    private drawChart() {
        d3.select(this.$el).select('svg').remove();
        const columnWidth = this.maxWidth / this.behaviorData.length;
        const svg = d3.select(this.$el).append('svg');
        svg.attr('width', this.maxWidth)
            .attr('height', this.maxHeight).append('g').attr('class', 'bar-chart');

        this.behaviorData.map((item: any, seq: number) => {
            this.drawColumn(item, seq, columnWidth);
        });
        this.drawSkyline();
    }

    private drawColumn(item: any, seq: number, columnWidth: number) {
        const barContainer = d3.select(this.$el).select('.bar-chart').append('g').attr('class', 'bar-group');
        const textContainer = d3.select(this.$el).select('.bar-chart').append('g')
        .attr('class', 'text-group')
        .attr('transform', `translate(${columnWidth * seq}, 5) rotate(90)`);
        let competencySeq: number = 0;
        const barHeight: number = this.maxHeight / this.maxCount;
        item.competencies.forEach((itemData: any) => {
            if (itemData.name === 'mastered') {
                this.skylinePoints.push({
                    x1: seq * columnWidth,
                    y1: barHeight * itemData.count,
                    x2: seq * columnWidth + columnWidth,
                    y2: barHeight * itemData.count,
                });
            }
            const competencyBox = new Array(itemData.count).fill({});
            competencyBox.forEach((element: any) => {
                barContainer.append('rect')
                .attr('class', itemData.name)
                .attr('x', seq * columnWidth)
                .attr('y', competencySeq * barHeight)
                .attr('width', columnWidth)
                .attr('height', barHeight);
                competencySeq++;
            });
        });


        if (this.isShowText) {
            const fb = textContainer.append('foreignObject')
                .attr('width', 200)
                .attr('height', columnWidth)
                .attr('y', -columnWidth);

            fb.append('xhtml:div')
                    .append('div')
                    .attr('class', 'text-item')
                    .html(item.label);
          }

    }

    private drawSkyline() {
        const svg = d3.select(this.$el).select('.bar-chart');
        const skylineBox = svg.append('g');
        let points = '';
        this.skylinePoints.map((skylinePoint: any) => {
            points += ` ${skylinePoint.x1},${skylinePoint.y1} ${skylinePoint.x2},${skylinePoint.y2}`;
          });
        skylineBox.append('polyline')
            .attr('points', points)
            .attr('class', 'skyline');
    }

}
